import { useHeadMeta } from '@sunrise-ui/primitives';
import type React from 'react';

interface CommunityMetaTagsProps {
  communityName?: string;
  communityDescription?: string;
  communitySlug?: string;
}

export const CommunityMetaTags: React.FC<CommunityMetaTagsProps> = ({
  communityName,
  communityDescription,
  communitySlug,
}) => {
  const title = communityName
    ? `${communityName} - Communiful`
    : 'Community - Communiful';

  const description = communityDescription
    ? communityDescription
    : `Join ${communityName || 'our community'} on Communiful. Connect with like-minded people, discover sessions, and build meaningful professional relationships.`;

  const url = communitySlug
    ? `https://app.joincommuniful.com/communities/${communitySlug}`
    : 'https://app.joincommuniful.com';

  const keywords = [
    'networking events',
    'professional connections',
    'conference app',
    'event networking',
    'community building',
    communityName,
  ]
    .filter(Boolean)
    .join(', ');

  useHeadMeta({
    title,
    description,
    keywords,
    openGraph: {
      title,
      description,
      image: '/og-image.png',
      url,
      type: 'website',
      siteName: 'Communiful',
    },
    twitter: {
      card: 'summary_large_image',
      title,
      description,
      image: '/og-image.png',
    },
    canonicalUrl: url,
  });

  return null; // This component doesn't render anything
};

export default CommunityMetaTags;
